import React, {useState} from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import {EventIntf} from "../ServerTypes";

function stringVal(json: any, key: string) {
    const v = json[key]
    if (v) {
        return v + ""
    } else {
        return ""
    }
}

export default function PartyVenueConfig(prop: {event: EventIntf, setValueSaver:(saver:() => string | null) => void}) {
    const venueData = JSON.parse(prop.event.venueData)
    const [partyName, setPartyName] = useState(stringVal(venueData, "partyName"))

    prop.setValueSaver(() => {
        return JSON.stringify({
            partyName: partyName
        })
    })
    return (
        <React.Fragment>
            <Typography variant="h6" gutterBottom>
                Party Info
            </Typography>
            <Grid item xs={12}>
                <TextField
                    required
                    id="eventName"
                    name="eventName"
                    label="Event Name"
                    onChange={(event) => {
                        setPartyName(event.target.value)
                    }}
                    value={partyName}
                    fullWidth
                />
            </Grid>
        </React.Fragment>
    );
}
